module.exports = new __parcel__URL__("spiritualbrilliance.0b03f204.png").toString();